export default {
    organization_public: {
        "default": "type_effects;header=organization_header;main=type_banner,type_images,type_videos,type_presentation,type_description,type_secondary_images,type_secondary_videos,type_agenda,type_detailed_infos,type_video,type_badges,type_tertiary_images,type_tertiary_videos,game_bunches,type_sponsors,type_share,type_terms,common_dynbody,type_demo_banner;footer=organization_footer,common_tenant_footer"
    },
}